import { Container, Row, Col, Button } from "react-bootstrap";
import { observer } from "mobx-react-lite";
import { useContext, useEffect } from "react";
import { Context } from "..";
import axios from "axios";
import { saveAs } from "file-saver";
import { useMediaQuery } from "react-responsive";

const Result8 = observer(() => {
  const mobile = useMediaQuery({ query: "(max-width: 1400px)" });

  const { col8 } = useContext(Context);

  const localData = JSON.parse(localStorage.getItem("data8"));

  let data;

  useEffect(() => {
    data = {
      c1: col8.cols8.c1 || localData.c1,
      c2: col8.cols8.c2 || localData.c2,
      c3: col8.cols8.c3 || localData.c3,
      c4: col8.cols8.c4 || localData.c4,
      c5: col8.cols8.c5 || localData.c5,
      c6: col8.cols8.c6 || localData.c6,
      c7: col8.cols8.c7 || localData.c7,
      res: col8.result8 || localData.res,
      word: col8.word8 || localData.word,
    };
  }, []);

  function createPdf() {
    axios
      .post(process.env.REACT_APP_HOST + "/create-pdf9", data)
      .then(() =>
        axios.get(process.env.REACT_APP_HOST + "/table9", { responseType: "blob" })
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        saveAs(pdfBlob, `table9.pdf`);
      });
  }

  return (
    <Container>
      <div className="divCol">
        {mobile ? (
          <>
            <Row style={{ marginTop: "0.75rem" }}>
              <Col className="colR">
                Гипергликемия у матери во время беременности ({'>'}5,6 ммоль/л)
              </Col>
              <Col className="colR2">{col8.cols8.c1 || localData.c1}</Col>
            </Row>
            <Row>
              <Col className="colR">Масса тела новорожденного более 90-го процентиля</Col>
              <Col className="colR2">{col8.cols8.c2 || localData.c2}</Col>
            </Row>
            <Row>
              <Col className="colR">
                Энцефалопатия новорожденного или другие нарушения церебрального статуса
              </Col>
              <Col className="colR2">{col8.cols8.c3 || localData.c3}</Col>
            </Row>
            <Row>
              <Col className="colR">
                Синдромом дыхательного расстройства у новорожденного
              </Col>
              <Col className="colR2">{col8.cols8.c4 || localData.c4}</Col>
            </Row>
            <Row>
              <Col className="colR">Врожденный порок сердца и/или врожденные аномалии системы кровообращения у новорожденного</Col>
              <Col className="colR2">{col8.cols8.c5 || localData.c5}</Col>
            </Row>
            <Row>
              <Col className="colR">Гипогликемия новорожденного в раннем неонатальном периоде ({'<'}2,6 ммоль/л)</Col>
              <Col className="colR2">{col8.cols8.c6 || localData.c6}</Col>
            </Row>
            <Row>
              <Col className="colR">
                Гиперплазия поджелудочной железы у новорожденного (увеличение размеров тела ({'>'}5,9 мм), и/или хвоста ({'>'}9,3 мм), и/или выше референсных значений)
              </Col>
              <Col className="colR2">{col8.cols8.c7 || localData.c7}</Col>
            </Row>
            <Row>
              <Col className="colR">z</Col>
              <Col className="colR2">-5,6</Col>
            </Row>
            <Row>
              <Col className="colR">p-вероятность</Col>
              <Col className="colR2">{col8.result8 || localData.res}</Col>
            </Row>
            <Row>
              <Col className="colR">Вероятность развития метаболических нарушений</Col>
              <Col className="colR2">{col8.word8 || localData.word}</Col>
            </Row>
          </>
        ) : (
          <>
            <Row style={{ marginTop: "0.75rem" }}>
              <Col className="colR">
                Гипергликемия у матери во время беременности ({'>'}5,6 ммоль/л)
              </Col>
              <Col className="colR" md={1}>
                Масса тела новорожденного более 90-го процентиля
              </Col>
              <Col className="colR">
                Энцефалопатия новорожденного или другие нарушения церебрального статуса
              </Col>
              <Col className="colR">
                Синдромом дыхательного расстройства у новорожденного
              </Col>
              <Col className="colR">Врожденный порок сердца и/или врожденные аномалии системы кровообращения у новорожденного</Col>
              <Col className="colR">Гипогликемия новорожденного в раннем неонатальном периоде ({'<'}2,6 ммоль/л)</Col>
              <Col className="colR">
                Гиперплазия поджелудочной железы у новорожденного (увеличение размеров тела ({'>'}5,9 мм), и/или хвоста ({'>'}9,3 мм), и/или выше референсных значений)
              </Col>
              <Col className="colR">z</Col>
              <Col className="colR">p-вероятность</Col>
              <Col className="colR">Вероятность развития метаболических нарушений</Col>
            </Row>
            <Row>
              <Col className="colR2">{col8.cols8.c1 || localData.c1}</Col>
              <Col className="colR2" md={1}>
                {col8.cols8.c2 || localData.c2}
              </Col>
              <Col className="colR2">{col8.cols8.c3 || localData.c3}</Col>
              <Col className="colR2">{col8.cols8.c4 || localData.c4}</Col>
              <Col className="colR2">{col8.cols8.c5 || localData.c5}</Col>
              <Col className="colR2">{col8.cols8.c6 || localData.c6}</Col>
              <Col className="colR2">{col8.cols8.c7 || localData.c7}</Col>
              <Col className="colR2">-5,6</Col>
              <Col className="colR2">{col8.result8 || localData.res}</Col>
              <Col className="colR2">{col8.word8 || localData.word}</Col>
            </Row>
          </>
        )}
        <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
          <Button
            onClick={createPdf}
            className="colLink"
            variant="outline-danger"
          >
            Скачать файл
          </Button>
        </div>
      </div>
    </Container>
  );
});

export default Result8;
